const scene = "chapter/";

export const UPDATE_CHAPTER = `${scene}UPDATE_CHAPTER`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;
